import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "And that's how holidays destroyed the world.",
  "description": "",
  "published": "2008-07-25T00:00:00.000Z",
  "redirect_from": ["/blog/and-thats-how-holidays-destroyed-the-world/swizec/90"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ever seen one of those "And that's how `}{`<`}{`something> destroyed the world. Mind how you go." cartoon shorts on Discovery Channel? Well if you haven't you truly are missing out on some quite fascinating butterfly effect/chain reaction commentaries that are enough to make anyone think twice about their actions.`}</p>
    <p>{`But I'm here today to talk a little bit about how the summer, or more specifically, people going on holidays might some day destroy the world. Over the summer various people go away from work for whatever reason they think of, they even get paid to go, which if you ask me is absurdity, and so since not everyone goes at the same time work grinds pretty much to a halt for everyone.`}</p>
    <p>{`Even when you personally are not on vacation somebody key to what you're doing might and it's very easy to run out of work to do like I did over the last week. In the end I just decided to stay home for a few days and I'll be going back to work on Monday, hopefully they'll have something for me to do. Probably will since we're getting designs for two projects I'm working on, but I digress.`}</p>
    <p>{`So let me think about some very far fetched causality here. Work grinds to a halt for many people who are not on vacation themselves. So many of them decide to simply not turn up for work and stay at home. Work begins piling up and they don't come back soon enough, so they get fired for being lazy. The ones on vacation come back and find themselves swamped with work, but since they're only getting paid for normal work they quit their jobs. None of the work gets done now and society as we know it implodes.`}</p>
    <p>{`Since I'm not very good at this just have a look at `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=b9AMClHYd4Y"
      }}>{`How computer games destroy the world`}</a>{` , `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=4bt0Lk9MtBU"
      }}>{`How transport destroys the world`}</a>{` and `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=3bKvVk1T6U4"
      }}>{`How rubbish destroys the world`}</a>{` .`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      